import { motion } from "framer-motion";

export const scrollToSection = (e, id) => {
  if (e) e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: 0, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.25em] text-[#184167]"
  >
    <span className="h-px w-8 bg-[#184167]/50" />
    {children}
  </span>
);
